// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"510":"216eee1d","588":"f93fa66a","840":"cbebba9d","976":"761278b7"}[chunkId] + ".css";
};